const SEARCH_CONSTANTS = {
	DEBOUNCE_DELAY: 500,
	SELECTOR: {
		SEARCH_INPUT: 'input[type="search"]',
		SEARCH_LABEL: '.search-field-label ',
		SEARCH_RESULTS: '[data-predictive-search-results]',
		EMPTY_RESULTS: '.header-search-popup-empty-results'
	}
};



class PredictiveSearch extends HTMLElement {
	constructor() {
		super();
		this.cachedResults = new Map();

		this.init();
	}

	init() {
		this.input = this.querySelector(SEARCH_CONSTANTS.SELECTOR.SEARCH_INPUT);
		this.predictiveSearchResults = this.querySelector(SEARCH_CONSTANTS.SELECTOR.SEARCH_RESULTS);
		this.sectionId = 'predictive-search';

		if (!this.input || !this.predictiveSearchResults) {
			console.warn('Required elements not found for predictive search');
			return;
		}

		this.setupEventListeners();
	}

	setupEventListeners() {
		const debouncedSearch = debounce(
			(event) => this.handleSearchInput(),
			SEARCH_CONSTANTS.DEBOUNCE_DELAY
		).bind(this);

		this.input.addEventListener('input', debouncedSearch);
	}

	handleSearchInput() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
	}

	async getSearchResults(searchTerm) {
		const queryKey = searchTerm.toLowerCase().replace(/\s+/g, '-');

		if (this.cachedResults.has(queryKey)) {
			this.renderSearchResults(this.cachedResults.get(queryKey));
			return;
		}

		try {
			const searchParams = new URLSearchParams({
				q: searchTerm,
				'resources[type]': 'product,query',
				'resources[limit]': '10',
				section_id: this.sectionId
			});

			const response = await fetch(`${window.routes.predictive_search_url}?${searchParams}`);

			if (!response.ok) {
				throw new Error(`Search request failed: ${response.status}`);
			}

			const text = await response.text();
			const doc = new DOMParser().parseFromString(text, 'text/html');
			const resultsMarkup = doc.querySelector(SEARCH_CONSTANTS.SELECTOR.SEARCH_RESULTS)?.innerHTML;

			if (!resultsMarkup) {
				this.close();
				return;
			}

			this.cachedResults.set(queryKey, resultsMarkup);

			const hasResults = !doc.querySelector(SEARCH_CONSTANTS.SELECTOR.EMPTY_RESULTS);


			this.renderSearchResults(resultsMarkup);

		} catch (error) {
			console.error('Search error:', error);
			this.showErrorState();
		}
	}

	renderSearchResults(resultsMarkup) {
		if (!resultsMarkup?.trim()) return;

		this.predictiveSearchResults.innerHTML = resultsMarkup;
		this.open();
	}

	open() {
		this.predictiveSearchResults.removeAttribute('style');
		this.querySelector(SEARCH_CONSTANTS.SELECTOR.SEARCH_LABEL)?.classList.add('search-results-active');
	}

	close() {
		this.predictiveSearchResults.innerHTML = '';
		this.predictiveSearchResults.style.display = 'none';
		this.querySelector(SEARCH_CONSTANTS.SELECTOR.SEARCH_LABEL)?.classList.remove('search-results-active');
	}

	showErrorState() {
		console.error("Sorry, something went wrong. Please try again.")
		// this.predictiveSearchResults.innerHTML = '<div class="search-error">Sorry, something went wrong. Please try again.</div>';
		// this.open();
	}
}

customElements.define('predictive-search', PredictiveSearch);

